import React, { createContext, useState, useContext } from 'react';

// Create a context
const SidebarContext = createContext();

// Create a provider component
export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Function to toggle the sidebar
  const toggleSidebar = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };

  // Function to toggle the sidebar with the opposite state
  const toggleSidebarWithOppositeState = () => {
    setIsSidebarOpen((prevIsSidebarOpen) => !prevIsSidebarOpen);
  };

  // Provide the context values to the children components
  const contextValues = {
    isSidebarOpen,
    toggleSidebar,
    toggleSidebarWithOppositeState,
  };

  return (
    <SidebarContext.Provider value={contextValues}>
      {children}
    </SidebarContext.Provider>
  );
};

// Custom hook to consume the context
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
